module.exports = __webpack_public_path__ + "img/comment-icon.9b6b2411.svg";